import ImagesAuthenticating11Png from '@/public/images/authenticating/1-1.png';
import ImagesAuthenticating12Png from '@/public/images/authenticating/1-2.png';
import ImagesAuthenticatingAuth1Svg from '@/public/images/authenticating/auth1.svg';
import ImagesAuthenticatingAuth2Svg from '@/public/images/authenticating/auth2.svg';
import ImagesAuthenticatingAuth3Svg from '@/public/images/authenticating/auth3.svg';
import ImagesAuthenticatingAuth4Svg from '@/public/images/authenticating/auth4.svg';
import ImagesAuthenticatingAuth5Svg from '@/public/images/authenticating/auth5.svg';
import ImagesAuthenticatingAuth6Svg from '@/public/images/authenticating/auth6.svg';
import ImagesAuthenticatingAuth7Svg from '@/public/images/authenticating/auth7.svg';
import ImagesAuthenticatingAuth8Svg from '@/public/images/authenticating/auth8.svg';
import ImagesAuthenticatingAuthenticating2Webp from '@/public/images/authenticating/authenticating2.webp';
import ImagesAuthenticatingAuthenticatingMobileWebp from '@/public/images/authenticating/authenticatingMobile.webp';
import ImagesAuthenticatingAuthenticatinglogoSvg from '@/public/images/authenticating/authenticatinglogo.svg';
import ImagesAuthenticatingFrame31Png from '@/public/images/authenticating/Frame3-1.png';
import ImagesAuthenticatingFrame32Png from '@/public/images/authenticating/Frame3-2.png';
import ImagesAuthenticatingFrame33Png from '@/public/images/authenticating/Frame3-3.png';
import ImagesAuthenticatingFrame34Png from '@/public/images/authenticating/Frame3-4.png';
import ImagesAuthenticatingLastSvg from '@/public/images/authenticating/last.svg';
import ImagesAuthenticatingOneImageWebp from '@/public/images/authenticating/oneImage.webp';
import ImagesAuthenticatingOption3Svg from '@/public/images/authenticating/option3.svg';
import ImagesAuthenticatingSection1Png from '@/public/images/authenticating/section1.png';
import ImagesAuthenticatingSection1Svg from '@/public/images/authenticating/section1.svg';
import ImagesAuthenticatingSection2Svg from '@/public/images/authenticating/section2.svg';
import ImagesAuthenticatingTagPng from '@/public/images/authenticating/tag.png';

export {
  ImagesAuthenticating11Png,
  ImagesAuthenticating12Png,
  ImagesAuthenticatingAuth1Svg,
  ImagesAuthenticatingAuth2Svg,
  ImagesAuthenticatingAuth3Svg,
  ImagesAuthenticatingAuth4Svg,
  ImagesAuthenticatingAuth5Svg,
  ImagesAuthenticatingAuth6Svg,
  ImagesAuthenticatingAuth7Svg,
  ImagesAuthenticatingAuth8Svg,
  ImagesAuthenticatingAuthenticating2Webp,
  ImagesAuthenticatingAuthenticatingMobileWebp,
  ImagesAuthenticatingAuthenticatinglogoSvg,
  ImagesAuthenticatingFrame31Png,
  ImagesAuthenticatingFrame32Png,
  ImagesAuthenticatingFrame33Png,
  ImagesAuthenticatingFrame34Png,
  ImagesAuthenticatingLastSvg,
  ImagesAuthenticatingOneImageWebp,
  ImagesAuthenticatingOption3Svg,
  ImagesAuthenticatingSection1Png,
  ImagesAuthenticatingSection1Svg,
  ImagesAuthenticatingSection2Svg,
  ImagesAuthenticatingTagPng,
};
